<script lang="ts">
    import { icons } from "../../../config"
    import { tooltip } from "../../../helper"
    import { openOverlay, showPrices, login } from "../../../store"
    import { getOperation, postAction } from "../../../api"
    import AddressField from "../../widgets/fields/AddressField.svelte"
    import CancellationField from "../../widgets/fields/CancellationField.svelte"
    import DateField from "../../widgets/fields/DateField.svelte"
    import DealerField from "../../widgets/fields/DealerField.svelte"
    import NumberField from "../../widgets/fields/NumberField.svelte"
    import SourceField from "../../widgets/fields/SourceField.svelte"
    import StatusField from "../../widgets/fields/StatusField.svelte"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import OperationPositionPriceSummary from "../../routes/operations/OperationPositionPriceSummary.svelte"
    import Icon from "../../widgets/Icon.svelte"
    import { mdiTag } from "@mdi/js"
    import { hasOpOutPermission, isAdmin } from "../../../../../api/hooks/config-client"
    import { _ } from "svelte-i18n"

    export let operation: Operation | OperationOut
    export let sharedView: boolean = false

    const getReferenceOperation = async () => {
        if (operation && "refNumber" in operation && operation.refNumber) {
            const response = await getOperation("operation", {
                number: operation.refNumber,
            })
            if (response?.data?.length) {
                return response.data[0]
            }
        }
    }

    const getCustomerOperation = async () => {
        const response = await getOperation("operation-out", {
            refNumber: operation.number,
        })
        if (response?.data?.length) {
            return response.data
        }
    }

    function calcluateSum() {
        let calcluatedSum = operation.positions
            .map((o) => {
                if (o.orderQuantity != undefined && o.orderQuantity === 0) {
                    return 0
                }
                return o.netPrice * o.quantity
            })
            .reduce((a, b) => a + b, 0)
        return calcluatedSum
    }
    function calculateSumWe() {
        let calculatedSumWe = operation.positions
            .map((o) => {
                if (o.orderQuantity != undefined && o.orderQuantity === 0) {
                    return 0
                }
                return o.residentialUnitsCount
            })
            .reduce((a, b) => a + b, 0)
        return calculatedSumWe
    }

    let calcluatedSum: number
    let calculatedSumWe = operation.residentialUnitsCount
    $: {
        if (operation.positions.some((o) => o.orderQuantity !== undefined)) {
            calcluatedSum = calcluateSum()
            calculatedSumWe = calculateSumWe()
        }
    }

    function filterValueUpdates(path: string) {
        let logs = operation.updateLogs
        if (!logs) return
        let valueUpdates = logs.filter((obj: { field: any }) => obj.field == path)
        let finalString = ""
        const getPrevious = (previous: string) => {
            if (previous == "null") return $_("positions.noPreviousEntry")
            if (previous == "true") return $_("general.yes")
            if (previous == "false") return $_("general.no")
            return previous
        }
        valueUpdates.forEach((o: { previous: any }) => {
            finalString += `<strong style="">${$_("positions.previousValue")}:</strong> ${getPrevious(
                o.previous
            )} <br/>`
        })

        return finalString
    }

    function hasValueUpdates(path: string) {
        let logs = operation.updateLogs
        if (!logs) return
        let valueUpdates = logs.filter((obj: { field: any }) => obj.field == path)
        return valueUpdates.length > 0 ? "marked" : ""
    }

    $: isOperationOut = "refNumber" in operation && Boolean(operation.refNumber)

    let externalLink: string = null
    async function loadExternalLink() {
        if (operation.source == 50) {
            const response = await postAction("getOperationShopLink", {
                operationId: operation.id,
            })
            console.log(response)
            externalLink = response?.data?.link
        } else {
            externalLink = null
        }
    }
    $: if (operation) loadExternalLink()
</script>

<div class="overlay_table1" class:mt-lg="{sharedView}" class:mb-lg="{sharedView}">
    <div class="table tableview responsive_table_overlay">
        {#if operation.type == 1}
            <div class="tablerow trow column1">
                {#if !sharedView}
                    <div class="col w-80 aligncenter">
                        <span class="title">{$_("operations.source")}</span>
                        <SourceField
                            value="{operation.source}"
                            additionalInfo="{operation.source == 10 && operation.clerk?.name
                                ? '(SB: ' + operation.clerk.name + ')'
                                : ''}"
                            {externalLink}
                        />
                    </div>
                {/if}
                {#if !sharedView}
                    <div
                        class="col w-80"
                        use:tooltip="{{
                            content: {
                                component: DealerField,
                                props: {
                                    number: operation.dealerNumber,
                                },
                            },
                        }}"
                    >
                        <span class="title">{$_("operations.customerNumber")}</span>
                        <span class="content">{operation.dealerNumber}</span>
                    </div>
                {/if}
                <div class="col w-150">
                    <span class="title">{$_("operations.offerDate")}</span>
                    <span class="content"
                        ><DateField
                            value="{operation.collectionName == 'operation'
                                ? operation.releaseDate
                                : operation.insertTime}"
                        /></span
                    >
                </div>
                <div
                    class="col mw-100 w-100"
                    class:marked="{hasValueUpdates(`releaseDate`)}"
                    use:tooltip="{{
                        content: `${filterValueUpdates(`releaseDate`) || ''}`,
                    }}"
                >
                    <span class="title">{$_("operations.offerNumber")}</span>
                    <span class="content">{operation.number}</span>
                </div>

                {#if !sharedView}
                    {#if !isOperationOut && (isAdmin($login) || hasOpOutPermission($login))}
                        <div class="col mw-100 w-100">
                            <span class="title">{$_("operations.outbound")}</span>
                            {#await getCustomerOperation()}
                                <div class="mt-sm">
                                    <MiniLoader />
                                </div>
                            {:then custOps}
                                {#if custOps?.length}
                                    <div style="max-width: 100%; overflow-x: auto; " class="layout layout-gap-xs">
                                        {#each custOps as custOp}
                                            <a
                                                href="{null}"
                                                class="content pointer layout layout-gap-xs align-items-center"
                                                on:click="{() => openOverlay(custOp)}"
                                                use:tooltip="{{
                                                    content: $_('operations.openCustomerOffer'),
                                                }}"
                                            >
                                                <div style="width: 18px;"><Icon path="{mdiTag}" /></div>
                                                {custOp.number}
                                            </a>{/each}
                                    </div>
                                {/if}
                            {/await}
                        </div>
                    {/if}
                    {#if isOperationOut}
                        <div class="col mw-100 w-100">
                            <span class="title">{$_("operations.origin")}</span>
                            {#await getReferenceOperation()}
                                <div class="mt-sm">
                                    <MiniLoader />
                                </div>
                            {:then refOp}
                                {#if refOp}
                                    <a
                                        href="{null}"
                                        class="content pointer layout layout-gap-xs align-items-center"
                                        on:click="{() => openOverlay(refOp)}"
                                        use:tooltip="{{
                                            content: $_('operations.openOriginalOffer'),
                                        }}"
                                    >
                                        <Icon path="{mdiTag}" />{refOp.number}
                                    </a>
                                {/if}
                            {/await}
                        </div>
                    {/if}
                {/if}

                <div class="col mw-80 w-80 aligncenter">
                    <span class="title">{$_("operations.numberOfPositions")}</span>
                    <span class="content"
                        >{operation.positions.filter(
                            (pos) => (!isNaN(pos.orderQuantity) ? pos.orderQuantity : pos.quantity) > 0
                        ).length}</span
                    >
                </div>
                <div class="col status mw-70 w-70">
                    <span class="title">{$_("operations.status")}</span>
                    <StatusField row="{operation}" />
                </div>
            </div>

            <div class="tablerow trow column2" class:shared-view="{sharedView}">
                <div class="col mw-120">
                    <span class="title">{$_("operations.inquiryDate")}</span>
                    <span class="content"><DateField value="{operation.inquiryDate}" /></span>
                </div>
                <div
                    class="col mw-100 w-100"
                    class:marked="{hasValueUpdates(`endCustomer.name`)}"
                    use:tooltip="{{
                        content: `${filterValueUpdates(`endCustomer.name`) || ''}`,
                    }}"
                >
                    <span class="title">
                        {#if isOperationOut}
                            {$_("operations.endCustomer")}
                        {:else}
                            {$_("operations.inquiryName")}
                        {/if}
                    </span>
                    <span class="content">
                        {"endCustomer" in operation ? operation.endCustomer?.name || "" : ""}
                    </span>
                </div>
                <div
                    class="col {isOperationOut ? 'mw-200 w-200' : 'mw-100 w-100'}"
                    class:markd="{hasValueUpdates(`endCustomerEmail`)}"
                    use:tooltip="{{
                        content: `${filterValueUpdates(`endCustomerEmail`) || ''}`,
                    }}"
                >
                    <div class="title">
                        {#if isOperationOut}
                            {$_("general.email")}
                        {:else}
                            {$_("operations.inquiryNumber")}
                        {/if}
                    </div>
                    <div class="content">
                        {#if isOperationOut}
                            {operation.endCustomerEmail || ""}
                        {:else}
                            {operation.inquiryNumber || ""}
                        {/if}
                    </div>
                </div>
                {#if isOperationOut}
                    <div
                        class="col w-120"
                        class:marked="{hasValueUpdates(`endCustomerPhone`)}"
                        use:tooltip="{{
                            content: `${filterValueUpdates(`endCustomerPhone`) || ''}`,
                        }}"
                    >
                        <span class="title">{$_("general.phone")}</span>
                        <span class="content">{operation.endCustomerPhone || ""}</span>
                    </div>
                {/if}
                <div
                    class="col w-140"
                    class:marked="{hasValueUpdates(`constructionProject`)}"
                    use:tooltip="{{
                        content: `${filterValueUpdates(`constructionProject`) || ''}`,
                    }}"
                >
                    <span class="title">{$_("operations.constructionProject")}</span>
                    <span class="content">{operation.constructionProject || ""}</span>
                </div>
                <div
                    class="col w-120"
                    class:marked="{hasValueUpdates(`commission`)}"
                    use:tooltip="{{
                        content: `${filterValueUpdates(`commission`) || ''}`,
                    }}"
                >
                    <span class="title">{$_("operations.commission")}</span>
                    <span class="content">{operation.commission || ""}</span>
                </div>
                <div
                    class="col w-140 hidden4000"
                    class:marked="{hasValueUpdates(`constructionSite`)}"
                    use:tooltip="{{
                        content: `${filterValueUpdates(`constructionSite`) || ''}`,
                    }}"
                >
                    <span class="title">{$_("operations.constructionSite")}</span>
                    <span class="content">{operation.constructionSite || ""}</span>
                </div>
                {#if operation.collectionName == "operation-out"}
                    <div
                        class="col w-120"
                        use:tooltip="{{
                            content: `${filterValueUpdates(`lastUpdatedBy.name`) || ''}`,
                        }}"
                    >
                        <span class="title">{$_("operations.lastUpdatedBy")}</span>
                        <span class="content">{operation?.lastUpdatedBy?.name || ""}</span>
                    </div>
                {:else}
                    <div
                        class="col w-120"
                        class:marked="{hasValueUpdates(`inquiryContact.name`)}"
                        use:tooltip="{{
                            content: `${filterValueUpdates(`inquiryContact.name`) || ''}`,
                        }}"
                    >
                        <span class="title">{$_("operations.inquiryContact")}</span>
                        <span class="content">{operation.inquiryContact?.name || ""}</span>
                    </div>{/if}
            </div>
        {:else if operation.type == 2}
            <div class="tablerow trow column1">
                {#if !sharedView}
                    <div class="col w-80 aligncenter">
                        <span class="title">{$_("operations.source")}</span>
                        <SourceField
                            value="{operation.source}"
                            additionalInfo="{operation.source == 10 && operation.clerk?.name
                                ? '(SB: ' + operation.clerk.name + ')'
                                : ''}"
                            {externalLink}
                        />
                    </div>
                {/if}
                {#if !sharedView}
                    <div
                        class="col w-80"
                        use:tooltip="{{
                            content: {
                                component: DealerField,
                                props: {
                                    number: operation.dealerNumber,
                                },
                            },
                        }}"
                    >
                        <span class="title">{$_("operations.customerNumber")}</span>
                        <span class="content">{operation.dealerNumber}</span>
                    </div>
                {/if}
                <div class="col w-100">
                    <span class="title">{$_("operations.orderNumber")}</span>
                    <span class="content">{operation.number}</span>
                </div>
                {#if !sharedView}
                    {#if !isOperationOut && (isAdmin($login) || hasOpOutPermission($login))}
                        <div class="col mw-100 w-100">
                            <span class="title">{$_("operations.outbound")}</span>
                            {#await getCustomerOperation()}
                                <div class="mt-sm">
                                    <MiniLoader />
                                </div>
                            {:then custOps}
                                {#if custOps?.length}
                                    <div style="max-width: 100%; overflow-x: auto;" class="layout layout-gap-xs">
                                        {#each custOps as custOp}
                                            <a
                                                href="{null}"
                                                class="content pointer layout layout-gap-xs align-items-center"
                                                on:click="{() => openOverlay(custOp)}"
                                                use:tooltip="{{
                                                    content: $_('operations.openCustomerOrderConfirmation'),
                                                }}"
                                            >
                                                <div style="width: 18px;"><Icon path="{mdiTag}" /></div>
                                                {custOp.number}
                                            </a>{/each}
                                    </div>
                                {/if}
                            {/await}
                        </div>
                    {/if}
                    {#if isOperationOut}
                        <div class="col mw-100 w-100">
                            <span class="title">{$_("operations.origin")}</span>
                            {#await getReferenceOperation()}
                                <div class="mt-sm">
                                    <MiniLoader />
                                </div>
                            {:then refOp}
                                {#if refOp}
                                    <a
                                        href="{null}"
                                        class="content pointer layout layout-gap-xs align-items-center"
                                        on:click="{() => openOverlay(refOp)}"
                                        use:tooltip="{{
                                            content: $_('operations.openOriginalOrder'),
                                        }}"
                                    >
                                        <Icon path="{mdiTag}" />{refOp.number}
                                    </a>
                                {/if}
                            {/await}
                        </div>
                    {/if}
                {/if}
                <div class="col w-80 aligncenter">
                    <span class="title">{$_("operations.numberOfPositions")}</span>
                    <span class="content"
                        >{operation.positions.filter(
                            (pos) => (!isNaN(pos.orderQuantity) ? pos.orderQuantity : pos.quantity) > 0
                        ).length}</span
                    >
                </div>
                <div class="col mw-160 w-160">
                    <span class="title">{$_("operations.status")}</span>
                    <StatusField row="{operation}" />
                </div>
                <div class="col w-60">
                    <span class="title">{$_("operations.cancellation")}</span>
                    <CancellationField statusSummary="{operation.statusSummary}" />
                </div>
            </div>
            <div class="tablerow trow column2" class:shared-view="{sharedView}">
                <div class="col w-120">
                    <span class="title">{$_("operations.orderDate")}</span>
                    <span class="content"><DateField value="{operation.releaseDate}" /></span>
                </div>
                <div class="col mw-100 w-100">
                    <span class="title">
                        {#if isOperationOut}
                            {$_("operations.endCustomer")}
                        {:else}
                            {$_("operations.inquiryName")}
                        {/if}
                    </span>
                    <span class="content">{"endCustomer" in operation ? operation.endCustomer?.name || "" : ""}</span>
                </div>
                <div class="col w-80">
                    <span class="title">{$_("operations.inquiryNumber")}</span>
                    <span class="content">{operation.inquiryNumber || ""}</span>
                </div>
                <div class="col w-170">
                    <span class="title">{$_("operations.constructionProject")}</span>
                    <span class="content">{operation.constructionProject || ""}</span>
                </div>
                <div class="col w-170">
                    <span class="title">{$_("operations.commission")}</span>
                    <span class="content">{operation.commission || ""}</span>
                </div>
                <div class="col w-170 hidden4000">
                    <span class="title">{$_("operations.constructionSite")}</span>
                    <span class="content">{operation.constructionSite || ""}</span>
                </div>
                <div class="col w-170">
                    <span class="title">{$_("operations.orderContact")}</span>
                    <span class="content">{operation.inquiryContact?.name || ""}</span>
                </div>
            </div>
        {/if}

        {#if !sharedView}
            <div class="tablerow trow column3">
                {#if !sharedView}
                    <div
                        class="col w-40 aligncenter"
                        use:tooltip="{{
                            content: ` ${filterValueUpdates(`residentialUnitsCount`) || ''} ${calculatedSumWe} ${$_(
                                'operations.residentialUnits'
                            )} `,
                        }}"
                        class:marked="{hasValueUpdates(`residentialUnitsCount`)}"
                    >
                        <span class="title">{$_("operations.we")}</span>
                        <span class="content">{calculatedSumWe}</span>
                    </div>
                {/if}

                {#if !sharedView && $showPrices && !location.pathname.includes("cart")}
                    <div
                        class="col w-80"
                        use:tooltip="{{
                            content: {
                                component: OperationPositionPriceSummary,
                                props: {
                                    operation,
                                },
                            },
                            className: 'bottom',
                        }}"
                    >
                        <span class="title">{$_("operations.sum")}</span>
                        <span class="content"
                            ><NumberField
                                value="{isNaN(calcluatedSum) ? operation.sumNetPrice : calcluatedSum || 0}"
                                unit="€"
                            /></span
                        >
                    </div>
                {/if}

                {#if !sharedView && $showPrices}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class="col rueckfrage w-80 aligncenter"
                        role="button"
                        tabindex="0"
                        on:click="{() => {
                            openOverlay(operation, 'inquiry', {
                                operation: operation,
                            })
                        }}"
                        use:tooltip="{{
                            content:
                                operation.type == 1 ? $_('operations.inquiryPlace') : $_('operations.inquiryOrder'),
                        }}"
                    >
                        <span class="title">{$_("operations.inquiry")}</span>
                        <span class="content"><Icon path="{icons.inquiry}" size="24px" /> </span>
                    </div>
                {/if}
            </div>
        {/if}
    </div>
    <!-- // Table -->

    {#if operation.type == 2}
        <div class="address">
            <span class="title">{$_("operations.deliveryAddress")}</span>
            <span class="content"><AddressField address="{operation.deliveryAddress}" /></span>
        </div>
    {/if}
</div>
